import { Tabs } from 'antd';
import MessagesAutoTranslate from '../Toolbar/MessagesAutoTranslate';
import SideRightChange from '../Toolbar/SideRightChange';
import { css } from '@emotion/css';

interface LightMessageEditorHeaderProps {
  showSideFold?: boolean;
  activeTab?: 'chat' | 'note';
  onTabChange?: (key: string) => void;
}

export const LightMessageEditorHeader = (props: LightMessageEditorHeaderProps) => {
  const { showSideFold, activeTab = 'chat', onTabChange } = props;

  return (
    <div className="flex items-center justify-between px-3">
      <Tabs className={tabsCls} size="small" activeKey={activeTab} onChange={onTabChange}>
        <Tabs.TabPane tab="Chat" key="chat" />
      </Tabs>
      <div className="flex items-center justify-center gap-4">
        <MessagesAutoTranslate />
        {showSideFold && <SideRightChange />}
      </div>
    </div>
  );
};

const tabsCls = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-nav .ant-tabs-tab {
    padding-top: 4px;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #232426;
    font-weight: 500;
  }
`;
